import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="mb-3">
      La ŝanĝoj en la vivo ne tro ekinteresis min. 
      Nu, alflugos ni al tiu Marso; nu, laborego malfacila – do kio? 
      Tutegale dumviva punlaboro. 
      Ĉu gravas ja, kie streĉiĝi ĝis la morto? 
      Kaj tie almenaŭ novajn lokojn mi ekvidos…
    </p>
    
    <p class="mb-3">
      Oni longe-persiste preparigis nin, rezonadis pri la respondeca rolo de Teranoj, pri grandeco de nia celo… 
      – al ni ja, al krimuloj, perfortuloj, murdistoj! 
      Poste oni surmetis al ni ĉiuj la verdajn uniformojn, kunkargis nin en la ŝipkelon kaj frapfermis la lukon.
    </p>
    
    <p class="mb-3">
      Post 10 horoj ni jam estis sur Marso. 
      Stranga malgranda Suno, kaj Tero – unu el steletoj, dume ne videbla sur la ĉielo. 
      Multaj ekkriis, ili falis, kisis la grundon, skuis manojn, minacante al tiu malproksima Tero, kiun ili ne vidis, sed ĝi determinis ĉiujn iliajn pensojn. 
      Eĉ de tioma distanco ĝi regposedis ilin, ĝi donis al ili la vivon plenan de malico kaj morno, kaj nun ĝi punis ilin pro ĉio; punis sian naskaĵon  - la homon – pro lia amara kaj mensogplena vivo.
    </p>
    
    <p class="mb-3">
      Minace trembrilis sur la ĉielo la Tero, kiam ni sternis litojn por dormi nian unuan nokton sur Marso.
    </p>

    <p class="text-center bold mb-3 mt-3">* * *</p>

    <p class="mb-3">
      Kaj ekde mateno komenciĝis laboro. 
      Ni fosis minojn, trenis vagonetojn, akiris ercon.
    </p>
    
    <p class="mb-3">
      Estus malprofite uzi ĉi tie maŝinojn: neniu maŝino eltenus longe en la marsa atmosfero. 
      Ankaŭ homoj ne eltenadis, sed ili ja akiratis de la ŝtato senpage! 
      La elspezoj por ilia vivsubtenado nenimaniere estus kompareblaj kun tiuj por kreado de speciala, korozi-rezista, incendi-sekura, altprecizeca tekniko en ekstertera varianto.
    </p>
    
    <p class="mb-3">
      Kaj male, la kontingento de homoj dume estis neelĉerpebla. 
      Dum lastaj jaroj, eĉ jardekoj, la nombro de leĝrompantoj kaj psikopatoj vidinde superis la nombron de leĝobeaj civitanoj.
    </p>
    
    <p class="mb-3">
      Homoj – iuj ajn homoj! - senhezite transpaŝis ĉiujn limojn; la murdo, krimo, perforto, - ĉio uzeblis por rimarkigi sin, distingigi sin de ĉirkaŭa amaso. 
      La epidemio de neŭraj malsanoj inundis la Teron.
    </p>
    
    <p class="mb-3">
      Ĉiuj funkcioj, postulantaj racion kaj cerbumon, antaŭlonge jam estis transdonitaj al maŝinaro. 
      Pri la majesta gloro de Scienc-Teknika Progreso kriadis ĉiuj Medioj de Deviga Aŭskultado; homoj vivis komforte kaj sate nur dank’ al maŝinoj.
    </p>
    
    <p class="mb-3">
      Ekskluzive sur la tabloj de elito foj-de-foje aperadis la natura nutraĵo; popolo jam delonge manĝis sintetikan manĝaĵon, vestis sintetikajn vestaĵojn, havis en siaj domoj sintetikan meblaron…
    </p>
    
    <p class="mb-3">
      La Tero devoris sin mem; ĝi, la kreanto de la homo, ĉesis esti bazo de lia vivo. 
      La homo pereigis ĉion, kio kunligis lin kun la naturo; kaj, siavice, li kreis sian propran pereigonton, la maŝinaron.
    </p>
    
    <p class="mb-3">
      Ne, la maŝinoj ne ribelis kontraŭ homo, kiel supozis naivaj verkistoj en oldaj bonaj tempoj de XX-a jarcento. 
      Ili humile plenumis ĉiujn ordonojn de la homo, sed – centfoje pli bone, pli perfekte, ol li  tion farus mem. 
      Poiomete iĝis malprofite eluzi la homan laboron tie, kie sukcese laboris maŝinoj; poiomete laborantaj homoj nuliĝis.
    </p>
    
    <p class="mb-3">
      Homo nur regis, ordonis, kaj la maŝino, ĉiam obeema, diligenta, rapidis fari ĉion senriproĉe. 
      Kaj homo klare vidis, sur kies flanko estas la avantaĝoj. 
      La libertempon por spekti kaj mediti li ja havis sufiĉege.
    </p>
    
    <p class="mb-3">
      Jen lante kaj glate, antaŭ liaj okuloj, la suba formo de ekzistado estis substituata per la pli alta, pli perfekta.
    </p>

    <p class="text-center bold mb-3 mt-3">* * *</p>

    <p class="mb-3">
      Dekomence krimulojn kaj psikozulojn oni izoladis, sed ilia kvanto kreskis kaj kreskis, kaj tiam aperis la ideo pri tuta liberigo de la Tero kontraŭ tiu balaaĵo, kiu nur malhelpas al novaj, progresemaj formoj de l’ vivo.
    </p>
    
    <p class="mb-3">
      Kaj jen tiumomente, dank’ al dio, oni priatentis tiujn minejojn sur Marso, kie neniu el maŝinoj volis labori. 
      Devas ja ili defendi siajn rajtojn! 
      Kaj la tutan tian homan biomason oni komencis transpumpi al Marso, por ke la Tero poiomete purigu sin de la restaĵoj de organika civilizacio.
    </p>
    
    <p class="mb-3">
      Niaj minejoj kreskis ne laŭ tagoj, sed laŭ horoj. 
      Ni loĝumadis Marson; multaj jam malbezonis la oksigenan balonon, iuj provis kreskigi florojn kaj arbojn sub siaj fenestroj.
    </p>
    
    <p class="mb-3">
      Pli praktikemaj homoj prisemis la kampojn per tritiko. 
    </p>
    
    <p class="mb-3">
      La grundon oni devis diligente prepari: per speciala kemiaĵo oni atribuis al ĝi gluecon, poste plantis la grenon kaj akvumis ne per pura akvo, sed per solvaĵo de la sama kemiaĵo, sen kiu la marsa grundo transformiĝis tuj al leĝera obskura polvo.
    </p>
    
    <p class="mb-3">
      Baldaŭ apud nia loĝloko aperis kelkaj grandaj kampoj, kultivis kiujn la tuta loĝantaro, alterne, en sia libera tempo.
    </p>
    
    <p class="mb-3">
      De kie ni prenis la grenon?
    </p>
    
    <p class="mb-3">
      Ja de la Tero oni sendus ion ajn, nur ke ni por ĉiam ekloĝu ĉi tie, paciĝu. 
      Ili ne preterlasis ideon, ke ni povas aneksi raketon, ribele reveni…  
      Ni ja estis krimuloj, murdistoj, perfortuloj.
    </p>
    
    <p class="mb-3">
      Kaj por kiu celo oni sur la Tero bezonus grenon? 
      Oni jam delonge tie ne manĝas. 
      Oni diras, ke homoj el la lastaj raketoj diris, ke robotoj eltrovis iun kampon (aŭ inventis mem, kiu scias, pri kio ili tie okupiĝas), kiu rekte liveras ilin per energio, do ili eĉ zorgi pri si mem ne devas. 
      Vi estis kreita – do vivu, plenumu vian devon; aliajn bezonojn vi ne havas, ĉar ili kontentiĝas tuj, momente.
    </p>
    
    <p class="mb-3">
      Jen homo – milionojn da jaroj lin kreadis la bezonoj manĝi, trinki, sin sekurigi, koiti. 
      Tuta lia historio estas nur akirado de manĝaĵo kaj de sekskunuloj por naski la sekvan generacion de la samaj estaĵoj. 
      Tio estis la ĉefa problemo, la senco de la tuta vivo: homo povis vivi, se li trifoje tage manĝis, kaj manĝis li por plue vivi por ankaŭ morgaŭ trifoje manĝi. 
      Ĉiu individuo luktis por si mem; ĉiu naskiĝis por akiri al si manĝon…
    </p>
    
    <p class="mb-3">
      Stranga estas tio. 
      Svarmo de unuopuloj. 
      Ĉiu pretendas esti aparta, unika – kaj efektive estas aparta, sed tute ne unika, sed absolute samspeca kiel aliuj, kaj nur pro sia aparteco ne scias tion. 
      Ridinda vidaĵo. 
      Aro de homoj ne estas homaro; tial homoj ne kreis komunan kulturon, unusolan grandan spiriton dum sia longa historio. 
      Ili ĉiam vivis dise, kaj el iliaj diversaj kaj diversdirektitaj streboj rezultiĝis… nenio, kiel nenio rezultiĝas de Brown’a movado de partikloj en akva guto. 
      La guto pro tio ne moviĝas; nur ĝia temperaturo altiĝos, se tiu movado iĝos tre intensa, kaj tiam la guto elvaporiĝos, pereos…
    </p>
    
    <p class="mb-3">
      Nu jen, venis la tempo perei por la svarmanta homaro, disigita je diversaj popoloj, diversaj sistemoj de percepto, de opinioj. 
      Inter tiuj sistemoj – ne konkordo, sed malamo; kaj eĉ ene de tiuj grupoj ĉiu dorlotas nur unusolan propran «MI», kaj pretas batali kontraŭ ĉiuj aliuj «MI» en la mondo.
    </p>
    
    <p class="mb-3">
      Kiel do ili freneziĝis, kiam ĉio tio okazis senbezona! 
      Kiam al la homo oni montris lian veran lokon, kaj li komprenis, kiom malalte valoras lia amata «individueco», kiel li estas malforta, senhelpa kaj malperfekta kompare al pli supera racio kaj povo – li, ĉiam sola – do, tion li elteni ne povis. 
    </p>
    
    <p class="mb-3">
      Jen tiam la homo komencis esprimi sian individuecon per la plej simpla kaj «potenca» rimedo – la perforto. 
      Sed ial komencis tion fari sametempe multaj homoj, kvazaŭ unusama teamo laŭ la odrono. 
      Ĉu individuecoj ne estas jam tiom apartaj kaj diversaj?
    </p>

    <p class="text-center bold mb-3 mt-3">* * *</p>
    
    <p class="mb-3">
      Ni atendis.
    </p>
    
    <p class="mb-3">
      Ni ne obstaklis al ili murdi unu la alian – tio ja devis okazi laŭ ilia propra evoluo. 
      Ni ekzilis ilin al la dezerta fora planedo, por ke ili komencu ĉion denove. 
      La homaro havas ankoraŭ unu ŝancon.
    </p>
    
    <p class="mb-3">
      Ili devas sin savi mem, ni sufloros al ili nenion. La savo de aliuj estas neebla. 
      La homaro fakte venis al la logika fino de tiu ĉi, individueca direkto de sia evoluo; nun ĝi povus ekhavi novan, kolektivan racion. 
    </p>
    
    <p class="mb-3">
      Dum longa historio, neniu ŝanĝis aŭ savis homojn, eĉ Jezuo Kristo. 
      Ni ne ŝanĝos homojn; antaŭ ni staras niaj propraj taskoj. 
      Ekzistas la Devo antaŭ la Estonteco, kaj ni plenumos ĝin.
    </p>
    
    <p class="mb-3">
      Sed homoj, sur sia nova planedo, aŭ renaskiĝos, aŭ formortos. 
      Alia solvo forestas.
    </p>

    <p class="text-center bold mb-3 mt-3">* * *</p>

    <p class="mb-3">
      Post 3 jaroj la abunde kovrita per komunaj kampoj planedo Marso fariĝis verda. 
      Tion oni kontente rimarkis de la Tero. 
      La Devo antaŭ la Estonto estis plenumita.
    </p>
    
    <p class="mb-3">
      Sed neniam teleskopoj de Marso rigardis al Tero, tiu forlasita azilo de frenezo kaj morto.
    </p>
    `
  )
}

const itemName = {
  esp: 'Retrovi la vojon'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;